export default function coursesBuy() {
    var _calculator = $(".section-calculator");
    var _minLicenses = 1;    

    setTimeout(function () {
        $('.ethena-standard, .ethena-standard .number-licenses__img').addClass('animate');
    }, 300);

    function product(people) {
        people = people*1;
        var _btn_buy = $("#courses-buy button");
        var _name = _calculator.attr('data-id');
        const standard_people   = _calculator.data('standard') * 1;
        const premium_people    = _calculator.data('premium') * 1;
        const enterprise_people = _calculator.data('enterprise') ? _calculator.data('enterprise') * 1 : premium_people + 1;
        const enterprise_on     = _calculator.data('enterprise-show') === 'true';

        if(premium_people > 0 && enterprise_people > 0 && standard_people < premium_people && premium_people < enterprise_people){
            if( ( people >= premium_people && people < enterprise_people ) || ( people >= enterprise_people && !enterprise_on )  ){
                _calculator.attr('data-id', 'premium');
                _btn_buy.hide();
            }else if( people >= enterprise_people && enterprise_on ){
                _calculator.attr('data-id', 'enterprise');
                _btn_buy.hide();
            }else if( people >= _minLicenses && people < premium_people ){
                _calculator.attr('data-id', 'standard');
                _btn_buy.show();
                _btn_buy.removeClass('disabled');
            } else {
                _calculator.attr('data-id', 'standard');
                _btn_buy.show();
                _btn_buy.addClass('disabled');
            }
    
            if( _calculator.attr('data-id') !== _name ) {
                $('.detail, .number-licenses__img').removeClass('animate');
                if( _name == 'standard'){
                    $('.body-form').removeClass('animate');
                }
                var course = $(".section-calculator").attr('data-id');
                $('.ethena-' + course + ', .ethena-' + course + ' .number-licenses__img').addClass('animate');
                setTimeout(function () {
                    $('.body-form').addClass('animate');
                }, 300);
            }
    
            if(people < _minLicenses) {
                $('.number-people').addClass('null');
                if(people < 0) {
                    $('.quantity input').val(0);
                }else{
                    $('.quantity input').val(people);
                }
            } else {
                $('.number-people').removeClass('null');
                $('.quantity input').val(people);
            }
        }
        $('#courses-buy input[name="licenses"]').val(people);
    }

    _calculator.on('click', '.more', function () {
        var _people = $('.quantity input').val();
        product(++_people);
    });

    _calculator.on('click', '.less', function () {
        var _people = $('.quantity input').val();
        product(--_people);
    });

    $('.section-calculator input').keyup(function () {
        var _people = $('.quantity input').val();
        product(_people);
    });

    $('.course').on('click', function () {
        var _selected = $(this).hasClass('selected');
        var _title = $(this).find('.course__title').text();
        if(!_selected){
            var _numberOfLicenses = $('.quantity input').val();
            var _nameOfProduct = $(this).data('id');

            $('#courses-buy input[name="product"]').val(_nameOfProduct);
            $('#courses-buy input[name="licenses"]').val(_numberOfLicenses);
            $('.btn-courses-buy span').text('Buy ' + _title);

            $('.course').removeClass('selected');
            $(this).addClass('selected');
        }
    });

    _calculator.on('click', '.btn-courses-buy', function (e) {
        var _numberOfLicenses = $('.quantity input').val();
        if(_numberOfLicenses < _minLicenses) {
            e.preventDefault();
            if (window.matchMedia("(orientation: portrait)").matches) {
                var _scroll = $('.section-calculator ').offset().top - $('.header').outerHeight() - 20;
                $([document.documentElement, document.body]).animate({
                    scrollTop: _scroll
                }, 850);
            }
        }
    });

    $('.courses').hover(function () {
        $(this).toggleClass('focus');
    });

    $('.course').hover(function () {
        $(this).toggleClass('hover');
    });

    $('.btn-courses .button[target="_blank"]').on('click', function (e) {
        $('.btn-courses .button[target="_blank"]').removeClass('btn-click');
    });

    $('.btn-courses .button').hover(function(){
        $(this).addClass('btn-click');
    }, function(){
        $(this).removeClass('btn-click');
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/coursesBuy.js